export default "__VITE_ASSET__C7FnKY1t__"